import cx from "classnames";
import SelectBox from "components/elements/selectBox";

const TimeRanger = ({ filter, setFilter, optDate = {} }) => {
    const handleChangeType = (type) => {
        setFilter((prev) => ({
            ...prev,
            time_type: type,
            time_range: optDate[type][0].value,
        }));
    };

    return (
        <div className="d-flex align-items-center mb-8 gap-10">
            <label className="form-label" style={{ minWidth: "130px", textAlign: "right" }}>
                Time Ranger
            </label>
            <div className="btn-group">
                <button
                    className={cx("btn btn-outline-info rounded-end rounded-pill border", {
                        active: !filter?.time_type || filter?.time_type === "daily",
                    })}
                    onClick={() => handleChangeType("daily")}
                >
                    Daily
                </button>
                <button
                    className={cx("btn btn-outline-info border", { active: filter?.time_type === "weekly" })}
                    onClick={() => handleChangeType("weekly")}
                >
                    Weekly
                </button>
                <button
                    className={cx("btn btn-outline-info rounded-start rounded-pill border", {
                        active: filter?.time_type === "monthly",
                    })}
                    onClick={() => handleChangeType("monthly")}
                >
                    Monthly
                </button>
            </div>
            <SelectBox
                options={optDate?.[filter?.time_type || "daily"] || []}
                value={filter?.time_range || optDate[filter?.time_type]?.[0].value || ""}
                placeholder={`Select Date`}
                onChange={(data) => {
                    setFilter((prev) => ({
                        ...prev,
                        time_range: data.value,
                    }));
                }}
            />
        </div>
    );
};

export default TimeRanger;
